import { z } from "zod";

export const dataPermissionSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    value: z.string().nullable(),
});
